import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicstoreSpinnia: Story = {
  id: 'magicstore-spinnia',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store spinnia',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 0.1 USDT in the Spinnia Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 0.1 USDT plus get a chance to win from a $300 prize pool.',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square,  Spinnia Campaign, USDT, Web3 App Store, Decentralized Apps, Crypto Rewards, Spinnia, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: '5ec8f360db6da9828d0b0e095d09a52ce058',
      scode: 'MagicSquare',
      ccode: 'T14jqkAokT',
    },
  },
};
